<!-- 对el-drawer的封装，增加底部操作栏插槽 -->
<template>
  <el-drawer v-bind="$attrs" v-on="$listeners">
    <!-- title区域 -->
    <template v-slot:title>
      <slot name="title"></slot>
    </template>
    <!-- body 区域 -->
    <template v-slot:default>
      <div class="drawer">
        <div class="drawer-body">
          <slot name="default"></slot>
        </div>
        <div class="drawer-footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </template>
  </el-drawer>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import '@/styles/element/drawer.scss';

.drawer {
  height: 100%;
  display: flex;
  flex-direction: column;
  .drawer-body {
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    padding: 24px;
    border-top: 1px solid #e5eaf2;
    border-bottom: 1px solid #e5eaf2;
  }
  .drawer-footer {
    display: flex;
    flex-direction: row-reverse;
    padding: 16px;
  }
}
</style>
